document.addEventListener('DOMContentLoaded', function () {
    const cart = document.getElementById('cart');

    const nextSibling = cart.nextElementSibling;
    const secondSibling = nextSibling ? nextSibling.nextElementSibling : null;

    if (secondSibling && secondSibling.classList.contains('add-on-wrapper') && secondSibling.classList.contains('active')) {
        const cartItems = cart.querySelector('.cart__items');
        if (cartItems) {
            cartItems.style.borderBottom = '1px solid #E5E5E5';
        }
    }
});

 (function () {
      if (window.__modshopSpecsToggleInit) return;
      window.__modshopSpecsToggleInit = true;

      var initModshopSpecToggles = function () {
        var toggles = document.querySelectorAll('.modshop-specs__toggle');
        if (!toggles.length) return;

        toggles.forEach(function (toggle) {
          toggle.addEventListener('click', function () {
            var targetId = toggle.getAttribute('data-target') || '';
            var list = document.getElementById(targetId);
            if (!list) return;

            var items = list.querySelectorAll('[data-spec-index]');
            var expanded = toggle.getAttribute('data-expanded') === 'true';
            items.forEach(function (item, idx) {
              if (idx >= 4) {
                if (expanded) {
                  item.classList.add('is-hidden');
                } else {
                  item.classList.remove('is-hidden');
                }
              }
            });
            toggle.setAttribute('data-expanded', expanded ? 'false' : 'true');
            toggle.textContent = expanded
              ? toggle.getAttribute('data-show-more') || 'Show more'
              : toggle.getAttribute('data-show-less') || 'Show less';
          });
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initModshopSpecToggles);
      } else {
        initModshopSpecToggles();
      }
    })();
